export default __webpack_public_path__ + "static/media/icon_arrow_right_dark.d27595cf.svg";